module.exports = __webpack_public_path__ + "static/media/photo263.dbee3957.jpg";